import { EIPDetails } from './Detail'

export default EIPDetails
